import { combineReducers } from 'redux';

import sellers from './sellers';
import seller from './seller';

export default combineReducers({
    sellers,
    seller
});
